<div class="routes"><VendorsSearch></VendorsSearch><GoogleMap></GoogleMap></div>